import {
  Button,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';

import { useWhatsNewStore } from './store/useWhatsNewStore';

export const WhatsNewModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    async function shouldShowModal() {
      if (!useWhatsNewStore.persist.hasHydrated()) {
        await useWhatsNewStore.persist.rehydrate();
      }
      setIsOpen(useWhatsNewStore.getState().shouldShowModal());
    }

    void shouldShowModal();
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    useWhatsNewStore.getState().dismissModal();
  };

  const confirmLink = t('whatsNew.confirmLink', { defaultValue: '' });
  const imageUrl = t('whatsNew.imageUrl', {
    defaultValue: '',
  });

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent
        maxW='594px'
        mx='0'
        my='6'
        p={{ base: '4', mobile: '10' }}
        color='text'
      >
        <HStack justify='space-between' pb='4'>
          <Text p='0' fontSize='h7' fontWeight='bold'>
            <Icon icon='info' boxSize='32px' mr='2' />
            {t('whatsNew.title')}
          </Text>

          <ModalCloseButton pos='static' />
        </HStack>

        <ModalBody p='0'>
          <VStack align='start' gap='6'>
            <Text fontSize='sm'>{t('whatsNew.description')}</Text>

            {imageUrl.length > 0 && (
              <Image w='full' borderRadius='lg' alt='' src={imageUrl} />
            )}

            <Text fontSize='lg' fontWeight='bold'>
              {t('whatsNew.contentTitle')}
            </Text>

            <Text fontSize='sm'>
              <Trans i18nKey='whatsNew.contentDescription' />
            </Text>

            {confirmLink.length > 0 ? (
              <HStack justify='space-between' w='full'>
                <Button fontSize='sm' onClick={handleClose} variant='text'>
                  {t('general.cancel')}
                </Button>
                <Button
                  onClick={() => {
                    window.open(t('whatsNew.confirmLink'), '_blank');
                    handleClose();
                  }}
                >
                  {t('whatsNew.confirmText')}
                </Button>
              </HStack>
            ) : (
              <HStack justify='end' w='full'>
                <Button fontSize='sm' onClick={handleClose}>
                  {t('general.close')}
                </Button>
              </HStack>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
